(() => {
  const root = document.querySelector('[data-tesevo-contact]');
  if (!root) return;

  document.documentElement.setAttribute('data-tesevo-contact-ready', 'true');
  const revealItems = root.querySelectorAll('[data-contact-reveal]');
  const form = root.querySelector('#TesevoContactForm');
  const topic = root.querySelector('#TesevoContactTopic');
  const orderField = root.querySelector('#TesevoContactOrder');
  const orderState = root.querySelector('[data-contact-order-state]');
  const orderHint = root.querySelector('#TesevoContactOrderHint');
  const vehicleField = root.querySelector('#TesevoContactVehicle');
  const vehicleState = root.querySelector('[data-contact-vehicle-state]');
  const vehicleHint = root.querySelector('#TesevoContactVehicleHint');
  const submitButton = root.querySelector('[data-contact-submit]');
  const submitLabel = root.querySelector('[data-contact-submit-label]');
  const formStatus = root.querySelector('[data-contact-form-status]');

  const setRequiredState = (field, label, hint, isRequired) => {
    if (!field || !label) return;
    field.required = isRequired;
    field.setAttribute('aria-required', String(isRequired));
    label.textContent = isRequired ? 'Required' : 'Optional';
    label.classList.toggle('is-required', isRequired);
    if (hint) hint.hidden = !isRequired;
  };

  const syncTopicRequirements = () => {
    const selectedTopic = topic?.value || '';
    const needsOrder = ['Existing order', 'Shipping or tracking', 'Return or exchange'].includes(selectedTopic);
    const needsVehicle = selectedTopic === 'Product fit or compatibility';
    setRequiredState(orderField, orderState, orderHint, needsOrder);
    setRequiredState(vehicleField, vehicleState, vehicleHint, needsVehicle);
  };

  topic?.addEventListener('change', syncTopicRequirements);
  syncTopicRequirements();

  form?.addEventListener('submit', (event) => {
    if (!form.checkValidity()) return;
    if (form.dataset.submitting === 'true') {
      event.preventDefault();
      return;
    }

    form.dataset.submitting = 'true';
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('is-loading');
    }
    if (submitLabel) submitLabel.textContent = 'Sending…';
  });

  if (formStatus) {
    window.requestAnimationFrame(() => formStatus.focus({ preventScroll: true }));
  }

  window.addEventListener('pageshow', () => {
    if (!form || !submitButton || !submitLabel) return;
    form.dataset.submitting = 'false';
    submitButton.disabled = false;
    submitButton.removeAttribute('aria-disabled');
    submitButton.classList.remove('is-loading');
    submitLabel.textContent = 'Send to TESEVO support';
  });

  if (!('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries, currentObserver) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      currentObserver.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });

  revealItems.forEach((item) => observer.observe(item));
})();
